module.exports = __webpack_public_path__ + "static/img/16.29da968.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/sp/16.png
// module id = ylfP
// module chunks = 0